import { render, staticRenderFns } from "./reflect-solid.vue?vue&type=template&id=89827710&"
import script from "./reflect-solid.vue?vue&type=script&lang=js&"
export * from "./reflect-solid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports